import { Component } from 'react'
import * as h from 'h'

import $ from 'jquery'
import { twitterUrl, linkedinUrl } from 'config'

import styles from './styles.scss'

class LinkedInShareButton extends Component {
  genURL () {
    return 'https://linkedin.com/shareArticle?' + $.param({
      url: this.props.url,
      title: this.props.text
    })
  }
  render () {
    return h.a({href: this.genURL(), target: '_blank'},
      h.img({src: '/img/linkedinShare.png', alt: 'Share on LinkedIn', className: styles.button}))
  }
}

class TwitterShareButton extends Component {
  genURL () {
    return 'https://twitter.com/share?' + $.param({
      url: this.props.url,
      text: '.@UConnResearch \n' + this.props.text
    })
  }
  render () {
    return h.a({href: this.genURL(), target: '_blank'},
      h.img({src: '/img/twitterShare.png', alt: 'Tweet it', className: styles.button}))
  }
}

export class ShareButtons extends Component {
  render () {
    return h.div({className: this.props.col && styles.buttonCol},
      h.h(LinkedInShareButton, {url: this.props.url, text: this.props.text}),
      h.h(TwitterShareButton, {url: this.props.url, text: this.props.text}))
  }
}

class LinkedInFollowButton extends Component {
  render () {
    return h.a({href: linkedinUrl, target: '_blank', rel: 'noopener noreferrer'},
      h.img({...h.ca(styles.button), src: '/img/linkedinFollow.png', alt: 'Follow us on LinkedIn'}))
  }
}

class TwitterFollowButton extends Component {
  render () {
    return h.a({ href: twitterUrl, target: '_blank', rel: 'noopener noreferrer' },
      h.img({...h.ca(styles.button), src: '/img/twitterFollow.png', alt: 'Follow us on Twitter'}))
  }
}

export class FollowButtons extends Component {
  render () {
    return h.div(h.ca(this.props.className),
      h.div(h.ca(styles.buttonRow),
        h.h(LinkedInFollowButton),
        h.h(TwitterFollowButton)
      )
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/SocialMedia/index.js